export { InfoBar } from './info-bar';
